import { isMobile } from 'react-device-detect';
import { type RouteParams } from 'atomic-router';
import { Link as RouterLink } from 'atomic-router-react';

import { closeBurgerMenu } from 'shared/mobileLayout';

export function Link<P extends RouteParams>(props: Parameters<typeof RouterLink<P>>[0]) {
  return <RouterLink onClick={isMobile ? () => closeBurgerMenu() : undefined} {...props} />;
}
